import 'unfetch/polyfill';
import React from 'react';
import { hydrate } from 'react-dom';
// import { BrowserRouter } from 'react-router-dom';
import BrowserRouter from '@empiriecom/module-components/BrowserRouter';
import App from '../components/App';

const namespace = process.env.FRAGMENT_NAMESPACE || 'og-emma';
const rootElem = window.document.getElementById('fragment-inspire-footer');

hydrate(
  <BrowserRouter>
    <App
      onlySocket={rootElem?.dataset.onlysocket === 'true'}
      clusterType={rootElem?.dataset?.clusterType || 'current'}
      // eslint-disable-next-line no-underscore-dangle
      data={(window as any).__cacheFooter}
    />
  </BrowserRouter>,
  document.getElementById(namespace),
);

if (module.hot) {
  module.hot.accept();
}
